export default "__VITE_ASSET__BxOjWSK1__"